import isMobileBrowser from 'is-mobile'

import { TopBar } from '@domain-group/suit-theme'

import useDashboardSearch from '@hooks/useDashboardSearch'
import type { FormattedResult, Result as ResultType } from '@hooks/useDashboardSearch'

import Result from './Result'

const isMobile = isMobileBrowser()

interface DashboardSearchProps {
  isSidebar?: boolean,
  resultsBoxProps?: object,
}

const DashboardSearch = (props: DashboardSearchProps) => {
  const {
    resultsBoxProps, isSidebar = false,
  } = props

  const {
    callbacks: {
      dashboardSearch,
      mapResults,
    },
  } = useDashboardSearch()

  return (
    <TopBar.Search
      // @ts-expect-error TS2322
      callbacks={{ search: dashboardSearch }}
      // @ts-expect-error TS2322
      mapResults={(data: ResultType[]) => mapResults(data)}
      // @ts-expect-error TS2322
      renderResult={(entity: FormattedResult) => (
        <Result
          isMobile={isMobile}
          isSidebar={isSidebar}
          key={entity.title}
          result={entity}
        />
      )}
      resultsBoxProps={{ ...resultsBoxProps, maxHeight: 350 }}
    />
  )
}

export default DashboardSearch
